"use client";

import { useEffect, useState } from "react";
import { useLenis } from "lenis/react";
import { removeExtraSpacesFromClassNames } from "@/utils/removeExtraSpacesFromClassNames";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG.client";
import styles from "./ScrollIndicator.module.scss";

/**
 * Decorative scroll-down indicator for the start page hero. Fades out and
 * becomes non-interactive once the user scrolls away from the top. Purely
 * visual, hidden from AT.
 */
export const ScrollIndicator = () => {
  const [isHidden, setIsHidden] = useState(false);
  const lenis = useLenis(({ scroll }) => {
    setIsHidden((currentIsHidden) => {
      const nextIsHidden = scroll > 0;

      return currentIsHidden === nextIsHidden ? currentIsHidden : nextIsHidden;
    });
  }, []);

  useEffect(() => {
    setIsHidden((lenis?.scroll ?? window.scrollY) > 0);
  }, [lenis]);

  const className = removeExtraSpacesFromClassNames(
    `${styles["scroll-indicator"]} ${isHidden ? styles["is-hidden"] : ""}`,
  );

  return (
    <span className={className} aria-hidden={true}>
      <CustomSVG
        iconKey="scroll_down"
        className={styles["scroll-down-icon"]}
        aria-hidden={true}
      />
    </span>
  );
};
